import { useEffect } from 'react'
import { createCombatTelemetry, recordCombatTransition, telemetryInvariantErrors, type CombatTelemetry } from './combatTelemetry'
import { useFightStore } from './store'

let liveTelemetry:CombatTelemetry=createCombatTelemetry()
export function getLiveCombatTelemetry():CombatTelemetry{return liveTelemetry}
export function resetLiveCombatTelemetry():CombatTelemetry{liveTelemetry=createCombatTelemetry();return liveTelemetry}
function publish(snapshot:CombatTelemetry){if(typeof window==='undefined')return;window.dispatchEvent(new CustomEvent('inyron:fight-telemetry',{detail:snapshot}))}
export function CombatTelemetryRuntime(){
  useEffect(()=>{
    resetLiveCombatTelemetry();publish(liveTelemetry)
    return useFightStore.subscribe((state,previous)=>{
      if(state.player===previous.player&&state.enemy===previous.enemy)return
      const dt=state.status==='fight'&&previous.status==='fight'&&previous.timer>=state.timer?previous.timer-state.timer:0
      liveTelemetry=recordCombatTransition(liveTelemetry,{beforePlayer:previous.player,afterPlayer:state.player,beforeEnemy:previous.enemy,afterEnemy:state.enemy,dt})
      const errors=telemetryInvariantErrors(liveTelemetry)
      if(errors.length){console.error('[fight-telemetry] invariant violation',errors);return}
      publish(liveTelemetry)
    })
  },[])
  return null
}
